export default __webpack_public_path__ + "static/media/feature.85b26d6a.jpg";